import { IConfig } from "@app/services/config/config.service";

export const environment: IConfig = {
    production: true,
    apiUrl: 'https://client-auth.prod.core.dssvc.io/api',
    apiKey: 'vTLjpdJMqq3b2Uw9uC8bX8mt8vgbLjE53ZZPQJGP',
};